import React from 'react'

import { Helmet } from 'react-helmet'
import { useHistory } from 'react-router-dom'

import './plants1.css'

const Plants1 = () => {
  const history = useHistory()

  const handleSignOut = () => {
    history.push('/')
  }

  const goToPlants = () => {
    history.push('/plants')
  }

  const goToContracts = () => {
    history.push('/contatcts')
  }

  const goToPenalty = () => {
    history.push('/penalty')
  }

  const goToDashboard = () => {
    history.push('/dashboard')
  }

  const goToReports = () => {
    history.push('/reports')
  }

  const goToMonitoring = () => {
    history.push('/monitoring')
  }

  const goToCctv = () => {
    history.push('/cctv')
  }

  const goToInventory = () => {
    history.push('/inventory')
  }

  const goToSettings = () => {
    history.push('/settings')
  }

  return (
    <div className="plants1-container1">
      <Helmet>
        <title>Plants1 - exported project</title>
        <meta property="og:title" content="Plants1 - exported project" />
        <link
          rel="canonical"
          href="https://namami-ganga-design-file-pvya6a.teleporthq.app/plants1"
        />
        <meta
          property="og:url"
          content="https://namami-ganga-design-file-pvya6a.teleporthq.app/plants1"
        />
      </Helmet>
      <div className="plants1-thq-plants-elm">
        <span className="plants1-thq-text-elm10">Plants</span>
        <img
          src="/bg1932-17g-300w.png"
          alt="BG1932"
          className="plants1-thq-bg-elm"
        />
        <div className="plants1-thq-settings-elm1" onClick={goToContracts}>
          <span className="plants1-thq-text-elm11">Contracts</span>
        </div>
        <div className="plants1-thq-settings-elm2" onClick={goToPenalty}>
          <span className="plants1-thq-text-elm12">Penalty</span>
        </div>
        <div className="plants1-thq-settings-elm3" onClick={goToReports}>
          <span className="plants1-thq-text-elm13">Reports</span>
        </div>
        <div className="plants1-thq-settings-elm4" onClick={goToMonitoring}>
          <span className="plants1-thq-text-elm14">Real time monitoring</span>
        </div>
        <div className="plants1-thq-settings-elm5">
          <span className="plants1-thq-text-elm15">Manpower</span>
        </div>
        <div className="plants1-thq-settings-elm6" onClick={goToInventory}>
          <span className="plants1-thq-text-elm16">Inventory</span>
        </div>
        <span className="plants1-thq-text-elm17">Collaboration</span>
        <span className="plants1-thq-text-elm18" onClick={goToCctv} role="presentation">
          CCTV Monitoring
        </span>
        <span className="plants1-thq-text-elm19" onClick={goToSettings} role="presentation">
          Settings
        </span>
        <div
          className="plants1-thq-dashboard-elm"
          onClick={goToDashboard}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') goToDashboard()
          }}
          role="button"
          tabIndex={0}
          style={{ pointerEvents: 'auto', cursor: 'pointer' }}
        >
          <span className="plants1-thq-text-elm20">Dashboard</span>
          <img
            src="/rectangle2891950-11k5-200h.png"
            alt="Rectangle2891950"
            className="plants1-thq-rectangle289-elm"
          />
        </div>
        <img
          src="/grid1951-5s3.svg"
          alt="Grid1951"
          className="plants1-thq-grid-elm"
        />
        <img
          src="/settings1952-2fk.svg"
          alt="Settings1952"
          className="plants1-thq-settings-elm7"
        />
        <img
          src="/ellipse37041954-69pa-200h.png"
          alt="Ellipse37041954"
          className="plants1-thq-ellipse3704-elm"
        />
        <img
          src="/ellipse37051955-mdx7-200h.png"
          alt="Ellipse37051955"
          className="plants1-thq-ellipse3705-elm"
        />
        <img
          src="/line4771956-hn8n.svg"
          alt="Line4771956"
          className="plants1-thq-line477-elm"
        />
        <img
          src="/line4781957-8sjg.svg"
          alt="Line4781957"
          className="plants1-thq-line478-elm"
        />
        <img
          src="/chevron1958-bemb.svg"
          alt="Chevron1958"
          className="plants1-thq-chevron-elm"
        />
        <img
          src="/image1959-wrxq-200h.png"
          alt="Image1959"
          className="plants1-thq-image-elm"
        />
        <span className="plants1-thq-text-elm21">Rajesh Nair</span>
        <span className="plants1-thq-text-elm22">Super Admin</span>
        <img
          src="/arrowexit1962-2iah.svg"
          alt="Sign out"
          className="plants1-thq-arrow-exit-elm"
          onClick={handleSignOut}
        />
        <img
          src="/alert1963-gustz.svg"
          alt="Alert1963"
          className="plants1-thq-alert-elm"
        />
        <div className="plants1-thq-frame99-elm">
          <div className="plants1-thq-frame101-elm1">
            <span className="plants1-thq-text-elm23">Active Sites</span>
          </div>
          <span className="plants1-thq-text-elm24">34</span>
        </div>
        <div className="plants1-thq-frame100-elm1">
          <div className="plants1-thq-frame101-elm2">
            <span className="plants1-thq-text-elm25">Green Plants</span>
          </div>
          <span className="plants1-thq-text-elm26">32</span>
        </div>
        <div className="plants1-thq-frame102-elm">
          <div className="plants1-thq-frame101-elm3">
            <span className="plants1-thq-text-elm27">Critical Alerts</span>
          </div>
        </div>
        <div className="plants1-thq-frame1984080068-elm">
          <div className="plants1-thq-frame101-elm4">
            <span className="plants1-thq-text-elm28">Total Penalties</span>
          </div>
          <span className="plants1-thq-text-elm29">₹50,000</span>
          <img
            src="/rectangle1301984-4q4-200h.png"
            alt="Rectangle1301984"
            className="plants1-thq-rectangle130-elm"
          />
          <span className="plants1-thq-text-elm30">8 violations</span>
        </div>
        <img
          src="/namamigangelogohindi11986-uhj-200h.png"
          alt="NamamiGangeLogoHindi11986"
          className="plants1-thq-namami-gange-logo-hindi1-elm"
        />
        <span className="plants1-thq-text-elm31" onClick={goToPlants} role="presentation">
          Plants
        </span>
        <div className="plants1-thq-frame100-elm2">
          <div className="plants1-thq-frame1984080066-elm">
            <div className="plants1-thq-frame101-elm5">
              <span className="plants1-thq-text-elm32">Device Details</span>
            </div>
            <span className="plants1-thq-text-elm33">Name :</span>
            <span className="plants1-thq-text-elm34">STP-01</span>
            <span className="plants1-thq-text-elm35">3007732</span>
            <span className="plants1-thq-text-elm36">Vendor Dr.</span>
            <span className="plants1-thq-text-elm37">Location :</span>
            <span className="plants1-thq-text-elm38">Vendor :</span>
          </div>
          <div className="plants1-thq-frame1984080067-elm">
            <div className="plants1-thq-frame101-elm6">
              <span className="plants1-thq-text-elm39">
                Device Details Panel
              </span>
            </div>
            <img
              src="/rectangle2901100-3jpc-200h.png"
              alt="Rectangle2901100"
              className="plants1-thq-rectangle290-elm"
            />
            <span className="plants1-thq-text-elm40">STP-01, Location</span>
            <span className="plants1-thq-text-elm41">Penalty Rules :</span>
            <span className="plants1-thq-text-elm42">
              If a penalty is selected, if penalty rules
            </span>
          </div>
          <span className="plants1-thq-text-elm43">
            Plants : STP Sites
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <span className="plants1-thq-text-elm44">Sites Manager : Plants</span>
          <img
            src="/bounds1100-tzki.svg"
            alt="Bounds1100"
            className="plants1-thq-bounds-elm1"
          />
          <span className="plants1-thq-text-elm45">Remain Plants</span>
          <img
            src="/search1101-zx0f.svg"
            alt="Search1101"
            className="plants1-thq-search-elm"
          />
          <img
            src="/bounds1101-w3rl.svg"
            alt="Bounds1101"
            className="plants1-thq-bounds-elm2"
          />
          <img
            src="/bounds1101-5t7n.svg"
            alt="Bounds1101"
            className="plants1-thq-bounds-elm3"
          />
          <span className="plants1-thq-text-elm46">Export Market PDF</span>
          <span className="plants1-thq-text-elm47">Export Cullorel</span>
          <div className="plants1-thq-frame2085664894-elm1">
            <span className="plants1-thq-text-elm48">09:30 AM</span>
            <span className="plants1-thq-text-elm49">09:30 AM</span>
            <span className="plants1-thq-text-elm50">Khushi Shroff</span>
            <span className="plants1-thq-text-elm51">Khushi Shroff</span>
            <span className="plants1-thq-text-elm52">Consultation</span>
            <span className="plants1-thq-text-elm53">Consultation</span>
            <span className="plants1-thq-text-elm54">Completed</span>
            <span className="plants1-thq-text-elm55">Completed</span>
            <img
              src="/rectangle2911102-5a4-200h.png"
              alt="Rectangle2911102"
              className="plants1-thq-rectangle291-elm"
            />
            <span className="plants1-thq-text-elm56">Status</span>
            <span className="plants1-thq-text-elm57">S No.</span>
            <span className="plants1-thq-text-elm58">Date</span>
            <span className="plants1-thq-text-elm59">Action</span>
            <span className="plants1-thq-text-elm60">COD</span>
            <span className="plants1-thq-text-elm61">Days</span>
            <img
              src="/line3611103-grt.svg"
              alt="Line3611103"
              className="plants1-thq-line361-elm"
            />
            <div className="plants1-thq-frame1000005073-elm">
              <span className="plants1-thq-text-elm62">Plant ID</span>
            </div>
            <span className="plants1-thq-text-elm63">Plant ID</span>
            <div className="plants1-thq-frame2085664891-elm">
              <span className="plants1-thq-text-elm64">Status</span>
            </div>
            <div className="plants1-thq-frame2085664892-elm">
              <span className="plants1-thq-text-elm65">COD</span>
            </div>
            <div className="plants1-thq-frame2085664893-elm">
              <span className="plants1-thq-text-elm66">Days</span>
            </div>
            <div className="plants1-thq-frame2085664894-elm2">
              <span className="plants1-thq-text-elm67">Date</span>
            </div>
            <img
              src="/rectangle346257251104-7lv-200h.png"
              alt="Rectangle346257251104"
              className="plants1-thq-rectangle34625725-elm"
            />
            <img
              src="/add1104-uhx.svg"
              alt="Add1104"
              className="plants1-thq-add-elm"
            />
            <img
              src="/line4741104-x9ye.svg"
              alt="Line4741104"
              className="plants1-thq-line474-elm"
            />
            <img
              src="/rectangle2921105-ozv-200h.png"
              alt="Rectangle2921105"
              className="plants1-thq-rectangle292-elm"
            />
            <span className="plants1-thq-text-elm68">1.</span>
            <span className="plants1-thq-text-elm69">Online</span>
            <span className="plants1-thq-text-elm70">STP-01</span>
            <span className="plants1-thq-text-elm71">2024-02-23</span>
            <span className="plants1-thq-text-elm72">120mg/L</span>
            <img
              src="/rectangle103691105-11y-200h.png"
              alt="Rectangle103691105"
              className="plants1-thq-rectangle10369-elm"
            />
            <img
              src="/delete1105-98h.svg"
              alt="Delete1105"
              className="plants1-thq-delete-elm"
            />
          </div>
        </div>
        <div className="plants1-thq-modal-elm">
          <div className="plants1-thq-icon-elm">
            <img
              src="/checkcirclesolid1i110-n6vf.svg"
              alt="checkcirclesolid1I110"
              className="plants1-thq-checkcirclesolid1-elm"
            />
          </div>
          <span className="plants1-thq-text-elm73">
            Data has been saved
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <img
            src="/closeiconi110-x3j3.svg"
            alt="CloseIconI110"
            className="plants1-thq-close-icon-elm"
          />
        </div>
      </div>
    </div>
  )
}

export default Plants1

